import {
  SELECT_CITY_FAILURE,
  SELECT_CITY_REQUEST,
  SELECT_CITY_SUCCESS,
  SELECT_COUNTRY_AIRPORT_FAILURE,
  SELECT_COUNTRY_AIRPORT_REQUEST,
  SELECT_COUNTRY_AIRPORT_SUCCESS,
  SELECT_COUNTRY_FAILURE,
  SELECT_COUNTRY_REQUEST,
  SELECT_COUNTRY_SUCCESS,
  SELECT_STATE_AIRPORT_FAILURE,
  SELECT_STATE_AIRPORT_REQUEST,
  SELECT_STATE_AIRPORT_SUCCESS,
  SELECT_STATE_FAILURE,
  SELECT_STATE_REQUEST,
  SELECT_STATE_SUCCESS,
} from './selectorType';

export const selectCountryRequest = () => {
  return {
    type: SELECT_COUNTRY_REQUEST,
  };
};

export const selectCountrySuccess = (data) => ({
  type: SELECT_COUNTRY_SUCCESS,
  payload: data,
});

export const selectCountryFailure = (error) => ({
  type: SELECT_COUNTRY_FAILURE,
  payload: error,
});

export const selectStateRequest = (id) => {
  return {
    type: SELECT_STATE_REQUEST,
    payload: id,
  };
};
export const selectStateSuccess = (data) => {
  return {
    type: SELECT_STATE_SUCCESS,
    payload: data,
  };
};
export const selectStateFailure = (error) => {
  return {
    type: SELECT_STATE_FAILURE,
    payload: error,
  };
};
export const selectCityRequest = (id) => {
  return {
    type: SELECT_CITY_REQUEST,
    payload: id,
  };
};
export const selectCitySuccess = (data) => {
  return {
    type: SELECT_CITY_SUCCESS,
    payload: data,
  };
};
export const selectCityFailure = (error) => {
  return {
    type: SELECT_CITY_FAILURE,
    payload: error,
  };
};
//
export const selectCountryAirportRequest = () => {
  return {
    type: SELECT_COUNTRY_AIRPORT_REQUEST,
  };
};

export const selectCountryAirportSuccess = (data) => ({
  type: SELECT_COUNTRY_AIRPORT_SUCCESS,
  payload: data,
});

export const selectCountryAirportFailure = (error) => ({
  type: SELECT_COUNTRY_AIRPORT_FAILURE,
  payload: error,
});
//
export const selectStateAirportRequest = (id) => {
  return {
    type: SELECT_STATE_AIRPORT_REQUEST,
    payload: id,
  };
};

export const selectStateAirportSuccess = (data) => ({
  type: SELECT_STATE_AIRPORT_SUCCESS,
  payload: data,
});

export const selectStateAirportFailure = (error) => ({
  type: SELECT_STATE_AIRPORT_FAILURE,
  payload: error,
});
